import { DEFAULT_LOCALE } from 'src/constants';

import { set } from './set';

async function fallback() {
  return set(DEFAULT_LOCALE);
}

export { fallback };
